import { AxiosResponse } from "axios";
import { RefundRequest } from "../../../models/Api/RefundRequests";
import { axiosInstance } from "../../../../../axiosInstance";

export interface IListResponse<T> {
  data: {
    items: [T];
    total: number;
    has_more: boolean;
    next_url: string | null;
  };
  success: boolean;
}

export const listRefundRequests = async (
  globalOrderId: string
): Promise<AxiosResponse<IListResponse<RefundRequest>>> => {
  return axiosInstance.get(`/global_orders/${globalOrderId}/refund_requests`);
};
